// tsx
// File: `web_app/components/GradientBorder.tsx`
import React from 'react';

interface Props {
  children?: React.ReactNode;
  className?: string;
}

const GradientBorder: React.FC<Props> = ({ children, className = '' }) => {
  return (
    <div
      className={`rounded-xl ${className}`}
      style={{
        border: '2px solid transparent',
        borderRadius: 12,
        background:
          'linear-gradient(white, white) padding-box, linear-gradient(45deg, #436dea 0%, #e20071 100%) border-box',
      }}
    >
      <div style={{ padding: 0, background: 'white', borderRadius: 9 }}>
        {children}
      </div>
    </div>
  );
};

export default GradientBorder;
